import { useEffect, useState, useRef, useCallback, createRef } from 'react';
import { Container, TitCiclo, Rotulo, Sensacao, DiadoMes, RodapeCiclo, RefFimCiclo, Obs } from './styles';
import { Simbols } from '../Simbols';
import { useAuth } from '../../hooks/Auth';
import Loading from '../../components/Loading';
import {api} from '../../services/api';
import { format, parseISO, addDays } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import useOnScreen from '../../hooks/onScreen';
import Estatistica from '../Estatistica';
import toast from 'react-hot-toast';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
import useCurrentWidth from '../../hooks/useCurrentwidth';

interface DataCiclo {
    user: any;
    ref?: any;
    totalciclos: number;
    idciclo: any;
    cicloatual?: boolean;
    i?: number;
    antigo?: boolean;
    changeNumdias: any;
    changeHighlight: any;
    hightLight: number;
    setShowmodal: any;
    datamodal: any;
    updateCiclo: boolean;
    idAllCiclos: any
}

const Ciclo: React.FC<DataCiclo> = ({ 
    user,
    totalciclos, 
    idciclo, 
    cicloatual = false, 
    i,
    antigo = false, 
    changeNumdias,
    changeHighlight,
    hightLight,
    setShowmodal,
    datamodal,
    updateCiclo,
    idAllCiclos
}) => {    
    const posicaociclo = i ? totalciclos - i : 0;
    const userlogado = useAuth();
    const userLogadoassina = userlogado.user.assinante ? parseFloat(userlogado.user.assinante) : 0;
    const userLogadovitalicio = userlogado.user.vitalicio ? parseFloat(userlogado.user.vitalicio) : 0;
    const [dadosciclo, setDadosCiclo] = useState([]);     
    const [load, setLoad] = useState(true);
    const linhaRef = useRef([]);
    const ref = useRef(null);    
    const isVisible = useOnScreen(ref); // para verifiar se o ciclo esta na tela, se tiver usca os dados
    const refBottomCiclo = useRef(null);    
    const isVisibleBC = useOnScreen(refBottomCiclo);    
    const [wfc, setWfc] = useState(0) // width do rodape de cada ciclo
    const [update, setUpdate] = useState(true);
    const [edit, setEdit] = useState(user.edit === 'on' || !user.hasOwnProperty('edit') ? true : false);
    const widthWindow = useCurrentWidth();
      
    const getCiclo = useCallback(async (e: any) => {    
        const params = e
        await api.get('/ciclos/readCiclo.php', { params : params })
        .then((resp: any) => {  
            //console.log(resp.data[0])            
            setDadosCiclo(resp.data[0]); 
            setLoad(false);
        }
        );        
    }, []);

    useEffect(() => {        
        let mounted = true;
        if(mounted){
            if(isVisible){
                try {
                    getCiclo({ iduser : user.iduser, idciclo: idciclo.numciclo, proximo: false });                    
                } catch (error) {
                    //console.log(error);
                }      
            }
        }
        return function cleanup() {
            mounted = false
        }
    }, [getCiclo, isVisible, updateCiclo, update, idciclo, user]); 
    
    useEffect(() => {
        setEdit(user.edit === 'on' || !user.hasOwnProperty('edit') ? true : false);
    }, [user])   

    useEffect(() => {
        if(!load){
            // alterando numeros (total) na coluna DIAS DO CICLO
            // console.log(dadosciclo.length);
            changeNumdias(dadosciclo.length);
            // criando ref e class para fazer o hover trocar de cor na linha toda
            if(dadosciclo.length > 0){
                linhaRef.current = dadosciclo.map((_, i) => linhaRef.current[i] ?? createRef());
            }       
        }
    }, [dadosciclo, changeNumdias, load]);

    const getWidthCiclo = useCallback((ref: any) => {        
            if(ref.current.offsetWidth){
                //console.log(ref.current.offsetWidth)
                setWfc(ref.current.offsetWidth);
            }        
    }, []) 

    useEffect(() => {   
        if(!load){
            getWidthCiclo(ref);
        }        
    }, [getWidthCiclo, load, widthWindow]);


    /* muda cor de todas as linhas do mesmo dia */
    function handleMouseOver(e: any){ 
        if(e){
            if(e.current){
                if(e.current.className){
                    let numerolinha = parseFloat(e.current.className.replace(/\D/gim, ''));        
                    changeHighlight(numerolinha);        
                }
            }
        }
    };

    /* add dia */
    function handleAddDia(){
        setShowmodal(true);

        const ultimodiaanotado = addDays(parseISO(dadosciclo[dadosciclo.length - 1]['dia']), 2);
        const numciclo = dadosciclo[0]['numciclo'];
        const iduser = dadosciclo[0]['id_user'];

        const alldaysciclo = dadosciclo.map((e : any) => e.id_mob && parseISO(e.dia));
        const excludedates = alldaysciclo.filter(n => n);

        datamodal({
            'component': 'add',
            'title': 'Adicionar Dia', 
            'diaini': format(ultimodiaanotado, "yyy-MM-dd"),  
            'diafim': '', 
            'numciclo': numciclo,
            'id_user' : iduser,
            'excludedates' : excludedates
        })
        
    }

    /* add dia vazio */
    function handleAddVacuo(e: string){
        setShowmodal(true);
        const ultimodiaanotado = addDays(parseISO(e), 0);
        const numciclo = dadosciclo[0]['numciclo'];
        const iduser = dadosciclo[0]['id_user'];
        datamodal({
            'component': 'add',
            'title': 'Adicionar Dia', 
            'diaini': ultimodiaanotado, 
            'diafim': ultimodiaanotado, 
            'numciclo': numciclo,
            'id_user' : iduser
        })
    }

    /* edit dia */
    function handleEdit(e: any){    
        setShowmodal(true);
        datamodal({'component': 'edit', 'title': 'Editar Dia', ...e})        
    }

    /* edit simbol (antigo)
    function handleEditSimb(e: any){
        setShowmodal(true);
        datamodal({'component': 'editsimb', 'title': 'Editar Símbolo', ...e});        
    } */

    function handleEditSimbCor(e: any){
      setShowmodal(true);
      datamodal({'component': 'editsimbcor', 'title': 'Editar Símbolos', ...e});        
    }
    /* edit cor (antigo) 
    function handleEditSelo(e: any){
        setShowmodal(true);
        datamodal({'component': 'editselo', 'title': 'Editar Selo', ...e});        
    }*/

    /* edit regra do dia */
    function handleEditRegraDia(e: any){
      setShowmodal(true);
      datamodal({'component': 'editregradia', 'title': 'Editar Regra', ...e});        
    }

    /* edit fertilidade */
    async function handleFertilidade(e: any){
        const fertilidade = e.fertilidade === null || e.fertilidade === '0' ? 11 : null;
        const send = {            
            "iduseredit": parseInt(userlogado.user.iduser),
            'fertilidade' : fertilidade, 
            "id_mob": parseFloat(e.id_mob),
            "id_user": parseInt(e.id_user),
            "dia" : e.dia,
            "sensacao": parseInt(e.sensacao),
            "obssensacao": e.obssensacao,
            "inifimciclo": e.inifimciclo,
            "numciclo": parseFloat(e.numciclo),
            "regra": parseFloat(e.regra),    
            "selo": parseFloat(e.selo),
            "relacao": parseFloat(e.relacao),  
            "regradia": parseFloat(e.regradia)      
        }
        try {
            await api.post('/ciclos/updateDia.php', send);
            toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
            setUpdate(!update);
        } catch (err: any) {
            const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
            toast.error(resp);
        }          
    }

    /* edit relacao */
    async function handleRelacao(e: any){
        const relacao = e.relacao === null || e.relacao === '0' ? 1 : null;
        const send = {            
            "iduseredit": parseInt(userlogado.user.iduser),
            'fertilidade' : e.fertilidade, 
            "id_mob": parseFloat(e.id_mob),
            "id_user": parseInt(e.id_user),
            "dia" : e.dia,
            "sensacao": parseInt(e.sensacao),
            "obssensacao": e.obssensacao,
            "inifimciclo": e.inifimciclo,
            "numciclo": parseFloat(e.numciclo),
            "regra": parseFloat(e.regra),    
            "selo": parseFloat(e.selo),
            "relacao": relacao,      
            "regradia": parseFloat(e.regradia)    
        }
        try {
            await api.post('/ciclos/updateDia.php', send);
            toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
            setUpdate(!update);
        } catch (err: any) {
            const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
            toast.error(resp);
        }          
    }

    
    /* delete all ciclo */
    function handleDelCiclo(){
        
        const send = {            
            "iduseredit": parseInt(userlogado.user.iduser),
            "id_user": parseInt(dadosciclo[0]['id_user']),
            "numciclo": parseFloat(dadosciclo[0]['numciclo']),       
        }
        
        confirmAlert({
            title: 'Confirme',
            message: 'Tem certeza que deseja apagar? esta ação não poderá ser desfeita e todo o ciclo será perdido.',
            buttons: [
            {
                label: 'SIM',
                onClick: async () => {
                    try {
                        await api.post('/ciclos/delCiclo.php', send);
                        toast.success('CICLO DELETADO COM SUCESSO, AGUARDE');
                        
                        setTimeout(function(){
                              window.location.reload();
                        }, 700);
            
                    } catch (err: any) {
                        const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR DELETAR';
                        toast.error(resp);
                    } 
                }
            },
            {
                label: 'Não',
                onClick: () => {}
            }
            ]
        });        
    }

    /* change position ciclo */
    function handlePosCiclo(){
        const todososciclos = idAllCiclos;
        setShowmodal(true);
        datamodal({
            'component': 'changeposciclo', 
            'title': 'MUDAR POSIÇÃO DO CICLO', 
            'id_user': dadosciclo[0]['id_user'], 
            'numciclo': dadosciclo[0]['numciclo'], 
            'allciclos': todososciclos
        });  
    }

    /* open Assine */
    function handleOpenAssine(){
        setShowmodal(true);
        datamodal({'component': 'assine', 'title': 'Assine versão Premium'});        
    }

    return(       
        <Container ref={ref} antigo={antigo}>
            {!load && dadosciclo.length > 0 ? (
                <>                
                <table>
                    <thead>
                        <tr>
                            <th><TitCiclo antigo={antigo}><h2>{cicloatual ? 'Ciclo Atual' : posicaociclo + 'º Ciclo'}</h2><span>início: {dadosciclo.length > 0 && format(parseISO(dadosciclo[0]['dia']), "dd MMM yyy", { locale: ptBR}) }</span></TitCiclo></th>
                            <th><Rotulo>Dias</Rotulo></th>
                            <th><Rotulo>Símbolo</Rotulo></th>
                            <th><Rotulo>Fertilidade</Rotulo></th>
                            <th><Rotulo>Relação</Rotulo></th>
                            <th><Rotulo>Regra</Rotulo></th>
                        </tr>
                    </thead>
                    <tbody className="hover">
                        
                        {dadosciclo.map((e: any, i: number) => 
                            <tr ref={linhaRef.current[i]} id={"linha"+i} className={`linha${i} ${hightLight === i ? 'hover' : ''}`} key={i+e.numciclo} onMouseEnter={() => handleMouseOver(linhaRef.current[i])}>
                                <td>
                                    {/*<div className={`hover ${!e.sensacao || e.obssensacao ? 'ajuste' : ''}`}></div>*/}
                                    <Sensacao edit={edit} obs={e.obssensacao ? true : false} onClick={e.sensacao !== null && edit ? () => handleEdit(e) : () => {} }>
                                        {e.sensacao !== null ? <span>{e.descsensacao}</span> : <button className={!edit ? 'disable' : ''} onClick={() => handleAddVacuo(e.dia)}>ADD ANOTAÇÃO</button>}
                                        {e.obssensacao && <Obs antigo={antigo} size={e.obssensacao ? e.obssensacao.length : 0}>{e.obssensacao}</Obs> }
                                    </Sensacao>
                                </td>
                                <td><DiadoMes><span>{format(parseISO(e.dia), "dd")}</span><small>{format(parseISO(e.dia), "MMM", {locale: ptBR})}</small></DiadoMes></td>
                                <td>
                                  {e.id_mob && <Simbols edit={edit} comp='simbol' regra={e.regra} click={() => {handleEditSimbCor(e)}} /> }
                                  {e.id_mob && <Simbols edit={edit} comp='selo' regra={e.selo} click={() => {}} /> }
                                </td>
                                <td>{e.id_mob && <Simbols edit={edit} comp='fertilidade' regra={e.fertilidade} click={() => handleFertilidade(e)} /> }</td>
                                <td>{e.id_mob && <Simbols edit={edit} comp='relacao' regra={e.relacao} click={() => handleRelacao(e)} /> }</td>
                                <td>{e.id_mob && <Simbols edit={edit} comp='regradia' regra={e.regradia} click={() => handleEditRegraDia(e)} />}</td>
                            </tr>
                                               
                        )}                                              
                    </tbody>
                </table>

                <RodapeCiclo isVisible={isVisibleBC} antigo={antigo} wfc={wfc} >
                    <Estatistica dadosciclo={dadosciclo}></Estatistica>
                    

                    {edit &&
                    <>
                    <button onClick={() => handleAddDia()} className="add">Adicionar Anotação</button>
                    <div className="treebtns">
                        <button onClick={() => handleDelCiclo()}>excluir ciclo</button>
                        <button onClick={() => handlePosCiclo()}>mudar posição</button>
                        {parseFloat(user.assinante) === 1 || parseFloat(user.vitalicio) === 1 || userLogadoassina === 1 || userLogadovitalicio === 1  ? (
                        <Link className='button' to={{
                            pathname: "/geraarquivo",
                            state: { cicloatual, posicaociclo, dadosciclo }
                            }}>imprimir</Link>                      
                        ) : (
                            <button onClick={() => handleOpenAssine()} >imprimir</button>
                        )}
                    </div>
                    </>
                    
                    }
                </RodapeCiclo>                
                </>
            ) : (
                <Loading />
            )}
            <RefFimCiclo ref={refBottomCiclo}></RefFimCiclo>
        </Container>
    )
}
export default Ciclo;